import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { ApplicationActions } from './application.actions';

export interface ApplicationState {
    periodTicketProgress: number;
    registrationProgress: number;
    registrationSteps: string[];
    recoverProgress: number;
    cartPending: boolean;
    customer: any;
    purchaseProgress: number;
    walletLoadingProgress: number;
    pageTitle: string;
    highContrast: boolean;
    assetsPath: string;
    ready: boolean;
    // TODO: move region and language from core state to application state
    // region: Region;
    // selectedLanguage: Language;
    termsUrl: string;
    userAgreedTermsVersionOnOnboarding: string; // version of terms user agreed to on onboarding
}
export const APPLICATION_INITIAL_STATE: ApplicationState = {
    periodTicketProgress: 0,
    registrationProgress: 0,
    registrationSteps: ['ACCOUNT_CREATION_PROGRESS_YOUR_DETAILS', 'ACCOUNT_CREATION_PROGRESS_VERIFY_EMAIL'],
    recoverProgress: 0,
    cartPending: false,
    customer: null,
    purchaseProgress: 0,
    walletLoadingProgress: 0,
    pageTitle: null,
    highContrast: false,
    assetsPath: './assets',
    ready: false,
    // region: null,
    // selectedLanguage: null,
    termsUrl: '',
    userAgreedTermsVersionOnOnboarding: null
};

export const APPLICATION_STATE_KEY = 'application';

export function applicationReducer(
    lastState: ApplicationState = APPLICATION_INITIAL_STATE,
    action: RidangoReduxAction
): ApplicationState {
    switch (action.type) {
        case ApplicationActions.SET_PERIOD_TICKET_PROGRESS:
            return tassign(lastState, { periodTicketProgress: action.payload });
        case ApplicationActions.SET_REGISTRATION_PROGRESS:
            return tassign(lastState, { registrationProgress: action.payload });
        case ApplicationActions.SET_RECOVER_PROGRESS:
            return tassign(lastState, { recoverProgress: action.payload });
        case ApplicationActions.SET_LOGGED_IN_CUSTOMER:
            return tassign(lastState, { customer: action.payload });
        case ApplicationActions.CART_PENDING:
            return tassign(lastState, { cartPending: action.payload });
        case ApplicationActions.SET_PURCHASE_PROGRESS:
            return tassign(lastState, { purchaseProgress: action.payload });
        case ApplicationActions.SET_WALLET_LOADING_PROGRESS:
            return tassign(lastState, { walletLoadingProgress: action.payload });
        case ApplicationActions.SET_PAGE_TITLE:
            return tassign(lastState, { pageTitle: action.payload });
        case ApplicationActions.SWITCH_HIGH_CONTRAST:
            return tassign(lastState, { highContrast: !lastState.highContrast });
        case ApplicationActions.SET_READY:
            return tassign(lastState, { ready: action.payload });
        case ApplicationActions.SET_ASSETS_PATH:
            return tassign(lastState, {
                assetsPath: action.payload
            });
        case ApplicationActions.SET_TERMS_URL:
            return tassign(lastState, {
                termsUrl: action.payload
            });
        case ApplicationActions.SET_USER_AGREED_TERMS_VERSION_ON_ONBOARDING:
            return tassign(lastState, { userAgreedTermsVersionOnOnboarding: action.payload });
    }
    return lastState;
}

export interface ApplicationPartialStoreState {
    [APPLICATION_STATE_KEY]: ApplicationState;
}
